module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD4AAAArCAMAAAAXBMteAAAAAXNSR0IArs4c6QAAADxQTFRFAAAAAFX/AGr/AG3/D2n/DWb/Dm74Dm7/EW//EW37EWz8Em38Em/8Em76EW77Em/7EW76Em76Em/7Em77NdqOnAAAABR0Uk5TAAMMDhEUJSUuPUlUVWF5kZKetsJWsZEkAAAAuElEQVRIx6XL2xKCMBCD4aIonvHw/u+qU9ChtJtk1/8yky+lXH/I9YnVDfk4dOUsekOL3tSSB1rwUFNPNPFUQy9o4CVtelEbXtZND/TxOnW2faW/5pLS5vGaulm+0qdZPPeJe6yZZxp7rpHfCRp5RRNPNfSCBl7Sphe14WXd9FtdN71DAy9p04va8LJueodueJeuvFOvvFsXPqAXfozohQ/plXfrwgf0wof0zwf17MM6+z/0x9+JfgOgxCupIOKQmwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/liucheng-jiantou.png
// module id = cc2t
// module chunks = 1